import { Inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { APP_SETTINGS } from '../../app-settings';
import { ApiResponse } from '../../../../common/models/api-response.interface';
import { User } from '../../../../common/models/user-interface';
import {
    Account,
    AccountType
} from '../../../../common/models/account.interface';
import { Observable } from 'rxjs';
import { InsertionOrder } from '../../../../common/models/insertion-order.interface';

@Injectable()
export class GeneralApiService {
    private apiEndpoint;

    constructor(
        private http: HttpClient,
        @Inject(APP_SETTINGS) private appSettings
    ) {
        this.apiEndpoint = appSettings.apiEndpoint;
    }

    public users(searchString): Observable<ApiResponse<User[]>> {
        return this.http
            .get<ApiResponse<User[]>>(`${this.apiEndpoint}users`, {
                params: { search: searchString }
            })
            .pipe(
                map(response => ({
                    ...response,
                    data: response.data.map((user: User) => ({
                        login_name: user.login_name,
                        email: user.email,
                        name: user.name,
                        id: user.id
                    }))
                })) // Restrict to user properties visible in Events
            );
    }

    public accounts(
        searchString?: string,
        types?: AccountType[]
    ): Observable<ApiResponse<Account[]>> {
        let params: Record<string, string> = {};

        if (searchString) {
            params.search = searchString;
        }

        if (types) {
            params.types = types.toString();
        }

        return this.http.get<ApiResponse<Account[]>>(
            `${this.apiEndpoint}accounts`,
            { params }
        );
    }

    public searchInsertionOrders(
        searchString: string
    ): Observable<ApiResponse<InsertionOrder[]>> {
        return this.http.get<ApiResponse<InsertionOrder[]>>(
            `${this.apiEndpoint}/ios`,
            {
                params: { search_string: searchString }
            }
        );
    }

    public parseErrorBlob(err: HttpErrorResponse): Observable<any> {
        // Temporary solution to convert blob error type to json.
        // https://github.com/angular/angular/issues/19888
        // Angular ticket open to fix the issue.
        const reader: FileReader = new FileReader();

        const obs = Observable.create((observer: any) => {
            reader.onloadend = e => {
                observer.error(JSON.parse(reader.result as string));
                observer.complete();
            };
        });
        reader.readAsText(err.error);
        return obs;
    }

    public getUsersByUid(payload: string[]) {
        return this.http.post<ApiResponse<any[]>>(
            `${this.apiEndpoint}users/`,
            payload
        );
    }
}
